import {StateLabel} from "@platform/models/state-labels/state-label"

// Maps each filter option to the concrete DB task types it covers. Several options batch
// multiple underlying task types (e.g. "Asset Rendering", "Utility") behind a synthetic key;
// the jobs filter expands the selected keys via this map. Test-only task types are excluded.
export const JobTaskTypeFilterValues: Record<string, string[]> = {
    "Rendering.cmRender": ["Rendering.cmRender"],
    UploadProcessing: ["UploadProcessing.metadata", "UploadProcessing.thumbnails"],
    "ImageProcessing.imageProcessing": ["ImageProcessing.imageProcessing"],
    "MaterialMapsExporter.updateExportConfig": ["MaterialMapsExporter.updateExportConfig"],
    "MaterialAi.imageToPbrMaps": ["MaterialAi.imageToPbrMaps"],
    Ar: ["Ar.gltf", "Ar.usdz", "ArGeneration.generate"],
    Tiling: ["Tiling.displacementGeneration", "Tiling.tiling"],
    Thumbnails: ["GenerateThumbnails.DataObject", "GenerateThumbnails.TextureSetRevision", "GenerateThumbnails.TypedDataObjectSet"],
    AssetRendering: [
        "AssetRendering.FabricOverview.postRenderStep",
        "AssetRendering.MaterialThumbnail.postRenderStep",
        "AssetRendering.ShaderBall.postRenderStep",
        "AssetRendering.TemplateThumbnail.postRenderStep",
        "AssetRendering.TileableMaterial.postRenderStep",
    ],
    Utility: [
        "Utility.createPostProcessingGraph",
        "Utility.dataObject",
        "Utility.textureEditGroup",
        "Utility.textureRevision",
        "Utility.textureSetRevision",
        "Utility.zip",
    ],
}

export const JobTaskTypeLabels: Map<string, StateLabel<string>> = new Map([
    ["Ar", {state: "Ar", label: "AR"}],
    ["AssetRendering", {state: "AssetRendering", label: "Asset Rendering"}],
    ["ImageProcessing.imageProcessing", {state: "ImageProcessing.imageProcessing", label: "Image Processing"}],
    ["MaterialAi.imageToPbrMaps", {state: "MaterialAi.imageToPbrMaps", label: "Material AI"}],
    ["MaterialMapsExporter.updateExportConfig", {state: "MaterialMapsExporter.updateExportConfig", label: "Material Export"}],
    ["Rendering.cmRender", {state: "Rendering.cmRender", label: "Rendering"}],
    ["Thumbnails", {state: "Thumbnails", label: "Thumbnails"}],
    ["Tiling", {state: "Tiling", label: "Tiling"}],
    ["UploadProcessing", {state: "UploadProcessing", label: "Upload"}],
    ["Utility", {state: "Utility", label: "Utility"}],
])
